import Vue from 'vue'
import Parse from 'parse'

let isDev = false
const ParsePlugin = {
    install(Vue) {
        if (isDev) {
            Parse.initialize('s6Ct6CtvDMIWoRlxveYddi9XDBBnhBvqj2tnwSwI'); // MyServe
            Parse.serverURL = 'http://localhost:1337/parse'
        } else {
            Parse.initialize(process.env.VUE_APP_APP_KEY); //  horganice Dev serve
            Parse.serverURL = process.env.VUE_APP_SERVER_URL; //
        }
        Vue.prototype.Parse = Parse
        Vue.prototype.Parse.Apartment = Parse.Object.extend('Apartment')
    }
}


Vue.use(ParsePlugin)